import { render, staticRenderFns } from "./Digitize.vue?vue&type=template&id=6559fe1c&scoped=true&"
import script from "./Digitize.vue?vue&type=script&lang=js&"
export * from "./Digitize.vue?vue&type=script&lang=js&"
import style0 from "./Digitize.vue?vue&type=style&index=0&id=6559fe1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6559fe1c",
  null
  
)

export default component.exports